var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseBurgerMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.6 22.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1a4d66;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -3.9,
    y: 9.42,
    width: 30.36,
    height: 3.71,
    rx: 1.86,
    transform: "translate(-4.67 11.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -3.86,
    y: 9.46,
    width: 30.36,
    height: 3.71,
    rx: 1.86,
    transform: "translate(11.32 27.33) rotate(-135)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBurgerMenu);
export default __webpack_public_path__ + "static/media/close_burger_menu.42f856158041d1223cba324dbc8af577.svg";
export { ForwardRef as ReactComponent };